import { EffectCallback, useEffect } from 'react';

const useOnMountEffect = (onMount: EffectCallback) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(onMount, []);
};

export default useOnMountEffect;
